<template>
    <ModalFigli
        v-model:visible="visible"
        @add="addFiglio"
    >
    </ModalFigli>
    <div class="m-auto px-20 pb-8">
        <div class="max-w-screen-2xl m-auto">
            <div class="py-10 flex justify-between">
                <Breadcrumbs :paths="paths"></Breadcrumbs>
                <div class="flex">
                    <NextButton variant="outline-secondary" @click="$router.back()"
                            class="w-48 hidden text-sm sm:block py-2 px-4">
                        &lt; Indietro
                    </NextButton>
                </div>
            </div>
            <h3 class="text-3xl font-bold mb-3">Nuovo Contatto</h3>
            <Alert v-if="permission_denied" class="bg-next-orange mb-5 sticky top-0 z-50">Non hai i permessi sufficienti per poter
                creare un contatto
            </Alert>
            <div class="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4">
                <div class="lg:col-span-2">
                    <div class="grid lg:grid-cols-2 gap-3">
                        <div class="flex flex-col pb-3">
                            <Field field_name="Nome" :required="true" v-model="contatto_model.nome"
                                   :errors="getErrors('nome')"></Field>
                        </div>
                        <div class="flex flex-col pb-3">
                            <Field field_name="Cognome" :required="true" v-model="contatto_model.cognome"
                                   :errors="getErrors('cognome')"></Field>
                        </div>
                        <div class="flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                            <Field field_name="Posizione lavorativa" :required="true"
                                   v-model="contatto_model.posizione_lavorativa"
                                   :errors="getErrors('posizione_lavorativa')"></Field>
                        </div>
                        <div class="flex flex-col pb-3 border-b border-next-gray-md-dark">
                            <Field field_name="Dipartimento" :required="true"
                                   v-model="contatto_model.dipartimento"
                                   :errors="getErrors('dipartimento')"></Field>
                        </div>

                        <div class="flex flex-col pb-3">
                            <Field field_name="Indirizzo email" :required="true" v-model="contatto_model.email"
                                   :errors="getErrors('email')"></Field>
                        </div>

                        <div class="flex flex-col pb-3">
                            <Field field_name="Metodo di contatto preferito" :required="false"
                                   v-model="contatto_model.contatto_predefinito"
                                   :errors="getErrors('contatto_predefinito')"></Field>
                        </div>

                        <div class="flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                            <Field field_name="Numeri di telefono" :required="false"
                                   v-model="contatto_model.telefono_1"
                                   :errors="getErrors('telefono_1')">
                                <div class="grid grid-cols-4 gap-3">
                                    <input v-model="contatto_model.telefono_1" placeholder="Numero telefono"
                                           class="col-span-3 p-2 bg-next-gray-md-dark hover:bg-white">
                                    <button class="bg-next-gray-md-dark"><i class="icon-telefono p-3"></i></button>
                                </div>
                            </Field>
                        </div>

                        <div class="flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                            <Field field_name="Numeri di telefono" :required="false" label-class="invisible"
                                   v-model="contatto_model.telefono_2"
                                   :errors="getErrors('telefono_2')">
                                <div class="grid grid-cols-4 gap-3">
                                    <input v-model="contatto_model.telefono_2" placeholder="Numero telefono"
                                           class="col-span-3 p-2 bg-next-gray-md-dark hover:bg-white">
                                    <button class="bg-next-gray-md-dark"><i class="icon-telefono p-3"></i></button>
                                </div>
                            </Field>
                        </div>

                        <div class="flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                            <Field field_name="Gruppo di appartenenza" :required="true"
                                   v-model="gruppoAutocomplete.selection"
                                   :errors="getErrors('gruppo_contatti_id')">
                                <VueMultiselect @search-change="gruppoAutocomplete.search"
                                                :loading="gruppoAutocomplete.isLoading"
                                                :options="gruppoAutocomplete.options"
                                                v-model="gruppoAutocomplete.selection"
                                                track-by="id" label="nome"
                                                placeholder="Gruppo"
                                                deselectLabel="Deseleziona"
                                                selectedLabel="Selezionato"
                                                selectLabel="Seleziona"
                                                tagPlaceholder="Aggiungi gruppo"
                                                class="next-vue-multiselect-single ">
                                    <template v-slot:noResult>Nessun elemento trovato.</template>
                                </VueMultiselect>
                            </Field>
                        </div>

                        <div class="flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                            <Field field_name="Account" :required="false"
                                   v-model="accountAutocomplete.selection"
                                   :errors="getErrors('accounts')">
                                <VueMultiselect v-model="accountAutocomplete.selection"
                                                :options="accountAutocomplete.options"
                                                :multiple="true"
                                                @search-change="accountAutocomplete.search"
                                                :close-on-select="false" :clear-on-select="false"
                                                placeholder="Accounts"
                                                deselectLabel="Deseleziona"
                                                selectedLabel="Selezionato"
                                                selectLabel="Seleziona"
                                                tagPlaceholder="Aggiungi account"
                                                class="next-vue-multiselect"
                                                track-by="id" label="name">
                                    <template v-slot:noResult>Nessun elemento trovato.</template>
                                    <template v-slot:tag="{option, remove}">
                                        <MultiselectOption @remove="remove(option)">
                                        <span class="border text-xs border-next-dark-gray px-2 rounded-sm mr-2">
                                            {{ option.bu_label || '&nbsp;' }}</span>
                                            <span>{{ option.name }}</span>
                                        </MultiselectOption>
                                    </template>

                                    <template v-slot:option="{option}">
                                        <span>
                                            <span class="text-sm border rounded-sm p-1">{{ option.bu_label }}</span>
                                            <span class="ml-2">{{ option.name }}</span>
                                        </span>
                                    </template>
                                </VueMultiselect>
                            </Field>
                        </div>
                    </div>
                </div>
                <div class="xl:col-span-1 lg:col-span-2 flex flex-col pb-3 lg:border-b border-next-gray-md-dark">
                    <Field field_name="Note" :required="false">
                        <textarea v-model="contatto_model.note" placeholder="Note"
                                  class="flex-grow p-5 bg-white"/>
                    </Field>
                </div>

                <div class="flex flex-col pb-3">
                    <Field field_name="Data di nascita" v-model="contatto_model.data_di_nascita"
                           placeholder="Data di nascita" type="date"
                        :errors="getErrors('data_di_nascita')">
                    </Field>
                </div>
                <div class="flex flex-col pb-3">
                    <Field field_name="Data ingresso in azienda" v-model="contatto_model.data_ingresso_in_azienda"
                           placeholder="Data ingresso in azienda" type="date"
                           :errors="getErrors('data_ingresso_in_azienda')">
                    </Field>
                </div>

                <div class="flex flex-col pb-3">
                    <Field field_name="Presente in azienda"
                           :errors="getErrors('presente')">
                        <Checkbox
                            checkClass="h-4 w-4"
                            :checked="contatto_model.presente"
                            @change="contatto_model.presente = !contatto_model.presente"
                            for_id="pm_esterno">
                        </Checkbox>
                    </Field>
                </div>


                <div class="flex flex-col pb-3">
                    <Field field_name="Stato civile" v-model="contatto_model.stato_civile" placeholder="Stato civile"
                           :errors="getErrors('stato_civile')">
                    </Field>
                </div>


                    <!--                        <div class="flex flex-col mb-3">-->
                    <!--                            <div class="flex justify-start items-center pb-2">-->
                    <!--                                <div class="font-bold">Figli</div>-->
                    <!--                                <i @click="modalAddFigli" class="cursor-pointer icon-croce_cerchiata text-2xl pl-3"></i>-->
                    <!--                            </div>-->
                    <!--                            <div class="grid grid-cols-2 gap-3 mb-3">-->
                    <!--                                <div v-for="(f,i) in contatto_model.figli" :key="i"-->
                    <!--                                     class="flex items-center bg-next-gray-md p-2 group border border-next-gray-md  hover:border-next-orange hover:bg-white">-->
                    <!--                                    <span class="flex-grow">{{ `${f.sesso} / ${f.eta} / ${f.nome}` }}</span>-->
                    <!--                                    <i tabindex="1" @click.stop.prevent="removeFiglio(i)"-->
                    <!--                                       class="cursor-pointer fa fa-times text-next-gray-md group-hover:text-next-orange p-0"></i>-->
                    <!--                                </div>-->
                    <!--                            </div>-->
                    <!--                        </div>-->

                <div class="flex flex-col pb-3">
                    <Field field_name="Hobbies e interessi">
                        <VueMultiselect v-model="hobbiesAutocomplete.selection"
                                        :options="hobbiesAutocomplete.options"
                                        :multiple="true"
                                        :taggable="true"
                                        @tag="(value)=>hobbiesAutocomplete.add({id:-1, nome:value})"
                                        @search-change="hobbiesAutocomplete.search"
                                        :close-on-select="false" :clear-on-select="false"
                                        class="next-vue-multiselect"
                                        track-by="id" label="nome"
                                        placeholder="hobby"
                                        deselectLabel="Deseleziona"
                                        selectedLabel="Selezionato"
                                        selectLabel="Seleziona"
                                        tagPlaceholder="Aggiungi hobby">

                            <template v-slot:tag="{option, remove}">
                                <MultiselectOption @remove="remove(option)">{{ option.nome }}
                                </MultiselectOption>
                            </template>
                        </VueMultiselect>
                    </Field>
                </div>
            </div>
            <div class="flex justify-end mt-3">
                <NextButton variant="outline-secondary" component="router-link"
                    :to="{name:'Contatti', params:{id}}"
                    class="w-44 py-2 px-4">
                    Annulla
                </NextButton>
                <NextButton variant="primary"
                    @click="save"
                    :disabled="saving"
                    class="w-44 ml-3 py-2 px-4">
                    Salva
                </NextButton>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
import {Options, Vue, setup} from 'vue-class-component';
import Topbar from "../components/Topbar.vue";
import Breadcrumbs from "@/components/Breadcrumbs.vue";
import Autocomplete from "@/setup/Autocomplete";
import hobbiesManager from "../api/Hobbies";
import contattiManager from "../api/Contatti";
import {Watch} from 'vue-property-decorator/lib/decorators/Watch';
import ModalFigli from "@/components/ModalFigli.vue";
import gruppiContattiManager from "../api/GruppiContatti";
import Alert from '@/components/Alert.vue';
import MultiselectOption from "@/components/MultiselectOption.vue";
import Field from "@/components/Field.vue";
import userManager from "../api/Users";
import NextButton from "@/components/NextButton.vue";
import Checkbox from "@/components/Checkbox.vue";

@Options({
    name:'FormContatto',
    components: {
        Checkbox,
        NextButton,
        Topbar,
        Breadcrumbs,
        ModalFigli,
        Alert,
        MultiselectOption,
        Field,
    },
    props: {
        id: [String, Number]
    }
})
export default class FormContatto extends Vue {

    hobbiesAutocomplete: any = setup(() => Autocomplete(hobbiesManager, true))
    gruppoAutocomplete: any = setup(() => Autocomplete(gruppiContattiManager))
    accountAutocomplete: any = setup(() => Autocomplete(userManager, true))

    id!: string | number
    visible = false
    saving = false
    permission_denied = false

    get paths() {
        return [
            {
                title: 'Home',
                name: 'Dashboard',
            },
            {
                title: 'Anagrafica',
                name: 'DettaglioAzienda',
                params: {id: this.id}
            },
            {
                title: 'Contatti',
                name: 'Contatti',
                params: {id: this.id}
            },
            {
                title: 'Nuovo contatto',
                name: 'FormContatto',
            },
        ]
    }

    @Watch('hobbiesAutocomplete.selection', {deep: true})
    sede_legale_comune(new_value: any, old: any) {
        this.contatto_model.hobbies = new_value
    }

    @Watch('gruppoAutocomplete.selection', {deep: true})
    gruppo(new_value: any, old: any) {
        this.contatto_model.gruppo_contatti_id = new_value ? new_value.id : null
    }

    contatto_model = {
        nome: null,
        cognome: null,
        dipartimento: null,
        posizione_lavorativa: null,
        stato_civile: null,
        data_di_nascita: null,
        data_ingresso_in_azienda: null,
        email: null,
        figli: [] as any[],
        telefono_1: null,
        telefono_2: null,
        contatto_predefinito: null,
        presente: true,
        hobbies: [],
        gruppo_contatti_id: null
    }

    errors = {}

    getErrors(field: string) {
        return (this.errors as any)[field]
    }

    save() {
        this.saving = true
        this.permission_denied = false
        contattiManager.contattiCreate(this.id, this.contatto_model).then((res: any) => {
            //@ts-ignore
            this.$router.replace({name: 'DettaglioContatto', params: {id: res.data.cliente_id, cid: res.data.id}})
        }).catch((res: any) => {
            if (res.response.status == 422) {
                this.errors = res.response.data.errors
            }
            if (res.response.status == 403) {
                this.permission_denied = true
            }
        }).finally(() => {
            this.saving = false
        })
    }

    modalAddFigli() {
        this.visible = true
    }

    addFiglio(value: any) {
        this.contatto_model.figli.push(value)
    }

    removeFiglio(i: number) {
        this.contatto_model.figli.splice(i, 1)
    }

    created() {
        this.hobbiesAutocomplete.search('', 0)
        this.gruppoAutocomplete.search('', 0)
    }

}
</script>


<style lang="scss">

</style>
